'use client'

import { useEffect } from 'react'

import { initMixpanelAnalytics } from './mixpanelAnalytics'

export const MixpanelAnalyticsProvider = () => {
  useEffect(() => {
    initMixpanelAnalytics()
  }, [])

  return null
}

export default MixpanelAnalyticsProvider
